import React from "react";
import { ArrowRight, PhoneCall } from "lucide-react";
import CraneScene from "@/components/honex/CraneScene";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      {/* Animated construction scene background */}
      <div className="absolute inset-0">
        <CraneScene />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/70 to-zinc-950/20" />
        <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 md:pt-44 md:pb-32 min-h-screen flex flex-col justify-center">
        <div className="reveal max-w-4xl">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-12 h-px bg-red-600" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-red-500">
              Honex GmbH
            </span>
          </div>
          <h1 className="font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black uppercase leading-[0.95] tracking-tighter">
            Kraftvoll.<br />
            Zuverlässig.<br />
            <span className="text-red-500">Honex.</span>
          </h1>
          <p className="mt-8 text-zinc-200 text-base sm:text-lg md:text-xl max-w-2xl font-light">
            Ihr Partner für <strong className="text-white font-semibold">Hochbau</strong>,{" "}
            <strong className="text-white font-semibold">Tiefbau</strong> und{" "}
            <strong className="text-white font-semibold">Industriebau</strong>. Wir realisieren
            anspruchsvolle Projekte mit Präzision, Verlässlichkeit und norddeutscher Beharrlichkeit.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#kontakt"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-3 bg-red-600 text-white px-8 py-5 text-sm font-bold uppercase tracking-widest hover:bg-red-700 transition-colors"
            >
              Projekt anfragen
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#leistungen"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-3 border-2 border-white text-white px-8 py-5 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-zinc-900 transition-colors"
            >
              Leistungen entdecken
            </a>
          </div>
        </div>
      </div>

      {/* Floating phone CTA */}
      <a
        href="tel:+4920143355633"
        data-testid="floating-phone"
        className="hidden md:flex absolute right-8 bottom-8 z-20 items-center gap-3 bg-white px-5 py-3 text-zinc-900 hover:bg-red-600 hover:text-white transition-colors"
      >
        <PhoneCall className="w-4 h-4" />
        <span className="text-xs font-bold uppercase tracking-widest">0201 43355633</span>
      </a>
    </section>
  );
}
